import React from 'react';

import { createBEM } from '../../../lib/utils/css';
import * as D from '../deps';

import './BackstageSocialLinkButtonRow.scss';

export interface IBackstageSocialLinkButtonOwnProps {
  text: string;
  link?: string;
  svg: React.FC<React.SVGProps<SVGSVGElement>>;
  isButtonWhite: boolean;
}

export type IBackstageSocialLinkButtonProps = IBackstageSocialLinkButtonOwnProps;

const BackstageSocialLinkButton: React.FC<IBackstageSocialLinkButtonProps> = props => {
  const buttonClasses = createBEM('SocialLinkButton', {
    whiteButton: props.isButtonWhite,
  });
  return props.link ? (
    <a href={props.link} target='_blank' rel='noreferrer'>
      <button className={buttonClasses}>
        {props.svg && <D.Icon glyph={props.svg} className='socialLinkButton_icon' />}
        {props.text}
      </button>
    </a>
  ) : null;
};

export default BackstageSocialLinkButton;
